import Vue from "vue";
import testSkeleton from "./assembly/skeleton.vue";
const loadingItms = {
  bind(el, binding) {
    const image = require("../assets/mybox/gif/lodaing.gif");
    const spinner = document.createElement("div");
    spinner.className = "loading-spinner";
    spinner.style.width = "100%";
    spinner.style.height = "101%";
    spinner.style.zIndex = 2025;
    spinner.style.background = "#ffffff";
    spinner.style.position = "fixed";
    spinner.style.opacity = 0.8;
    spinner.style.top = "0";
    spinner.style.left = "0";
    // spinner.style.transform = "translate(-50%, -50%)";
    spinner.style.display = "none";
    const ContentBox = document.createElement("div");
    ContentBox.className = "content-box";

    const spinnerContent = document.createElement("div");
    spinnerContent.className = "spinner-content";
    spinnerContent.style.backgroundImage = `url(${image})`;
    spinnerContent.style.width = "1rem";
    spinnerContent.style.height = "1rem";
    const ContentText = document.createElement("div");
    ContentText.className = "content-text";

    ContentText.innerText = "loading…";
    const spinnerStyle = document.createElement("style");
    spinnerStyle.type = "text/css";
    spinnerStyle.innerHTML = `
          .content-box {
            position :absolute;
            top:50%;
            left:50%;
            transform:translate(-50%, -50%);
            text-align:center;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            .spinner-content{
                background-size: cover;
                background-size: 100% 100%;
            }
            .content-text{
                margin-top:0.2rem;
                font-size:0.2rem;
               
               color: #C8C8C8;
            }
          }
        `;
    document.head.appendChild(spinnerStyle);

    el.style.position = "relative";
    el.spinner = spinner;
    el.appendChild(spinner);
    spinner.appendChild(ContentBox);
    ContentBox.appendChild(spinnerContent);
    ContentBox.appendChild(ContentText);
    if (binding.value) {
      spinner.style.display = "block";
    }
  },
  update(el, binding) {
    if (binding.value) {
      el.spinner.style.display = "block";
    } else {
      el.spinner.style.display = "none";
    }
  },
  unbind(el) {
    if (el.spinner && el.spinner.parentNode) {
      el.spinner.parentNode.removeChild(el.spinner);
    }
  },
}; //加载
const skeleton = {
  bind(el, binding, vnode) {
    // 创建组件构造器
    const ComponentConstructor = Vue.extend(testSkeleton);
    // 创建组件实例
    const instance = new ComponentConstructor({
      propsData: {
        ...binding.value,
      }, // 传递指令值作为组件的 props
    }).$mount();

    // 将组件实例保存在元素上
    el.myComponentInstance = instance;

    // 插入组件元素
    if (binding.value.show) {
      el.appendChild(instance.$el);
    }
  },
  update(el, binding) {
    if (binding.value.show) {
      if (!el.myComponentInstance.$el.parentNode) {
        el.appendChild(el.myComponentInstance.$el);
      }
    } else {
      if (el.myComponentInstance.$el.parentNode) {
        el.removeChild(el.myComponentInstance.$el);
      }
    }
  },
  unbind(el) {
    if (el.myComponentInstance.$el.parentNode) {
      el.removeChild(el.myComponentInstance.$el);
    }
    el.myComponentInstance.$destroy();
  },
}; //骨架屏
const text_ellipsis = {
  bind(el, binding, vnode) {
    const maxLength = binding.value;
    const text = el.innerText;

    if (text.length > maxLength) {
      el.innerText = text.slice(0, maxLength) + "...";
    }
  },
};//字符超出指定数量...省略

export { loadingItms, skeleton,text_ellipsis };
